// @flow

import ApiObject from '../ApiObject';
import _ from 'lodash';

export default class KioskOrderTicketSettings extends ApiObject {

  static CUSTOM_TEXT_MAX_LENGTH = 400;

  customText: string = '';
}
